/**
 * Organisation Hierarchies routes — FSD 1.2.9.
 *
 * `src/router/index.ts` is wired by the orchestrator after every C14 W3 packet lands (this
 * packet's brief, §"Scope boundaries"); this module only declares its own record array for
 * that later merge. Same shape as `modules/org/routesC1.ts` and the sibling
 * `../reference-sets/routes.ts`.
 *
 * Every route is gated on the **read** permission. FSD 1.2.9.1 names Internal Audit,
 * Finance, HR, Security and Analytics as consumers of hierarchies who approve or read but
 * do not define them, and the server gates validate, compare and resolve on read alone — so
 * a reader can open every screen here, run a validation, diff two versions and resolve any
 * date, and change nothing. Arrange, submit, publish and rollback are each checked on the
 * action, by the screen and again by the server.
 */

import type { RouteRecordRaw } from 'vue-router'

import { HIERARCHY_PERMISSIONS } from './permissions'

export const HIERARCHY_ROUTES: RouteRecordRaw[] = [
  {
    path: '/enterprise/hierarchies',
    name: 'enterprise-hierarchies',
    component: () => import('./HierarchiesView.vue'),
    meta: {
      titleKey: 'enterprise.hierarchies.routeTitles.register',
      permission: HIERARCHY_PERMISSIONS.read,
    },
  },
  {
    path: '/enterprise/hierarchies/:hierarchyId/versions/:versionId',
    name: 'enterprise-hierarchy-version',
    component: () => import('./HierarchyVersionView.vue'),
    meta: {
      titleKey: 'enterprise.hierarchies.routeTitles.version',
      permission: HIERARCHY_PERMISSIONS.read,
    },
  },
  {
    path: '/enterprise/hierarchies/:hierarchyId/compare',
    name: 'enterprise-hierarchy-compare',
    component: () => import('./CompareVersionsView.vue'),
    meta: {
      titleKey: 'enterprise.hierarchies.routeTitles.compare',
      permission: HIERARCHY_PERMISSIONS.read,
    },
  },
  {
    path: '/enterprise/hierarchies/:hierarchyId/resolve',
    name: 'enterprise-hierarchy-resolve',
    component: () => import('./ResolveAsAtView.vue'),
    meta: {
      titleKey: 'enterprise.hierarchies.routeTitles.resolve',
      permission: HIERARCHY_PERMISSIONS.read,
    },
  },
]
